module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0112.jpg?v=00f153af";